/* eslint-disable import/no-unresolved */
/// Zappar for ThreeJS Examples
/// Portal

// In this image tracked example we'll mask and render passes to create a
// 'portal' effect. It will look like we are looking into a room - please
// try moving your mobile device around to see the full effect.

import * as THREE from 'three';
import * as ZapparThree from '@zappar/zappar-threejs';
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { ClearPass } from 'three/examples/jsm/postprocessing/ClearPass';
import { MaskPass, ClearMaskPass } from 'three/examples/jsm/postprocessing/MaskPass';
import { CopyShader } from 'three/examples/jsm/shaders/CopyShader';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';

import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

const foliage = new URL('../assets/margaret-river-art-trails-fav.png', import.meta.url).href;
const grid = new URL('../assets/grid.jpg', import.meta.url).href;

const targetImage = new URL('../assets/MR_ART_05.zpt', import.meta.url).href;

const BGImage = new URL('../assets/MR_ART_05_brownbg.jpg', import.meta.url).href;


const model  = new URL('../assets/glb/MR_ART_05_36.glb', import.meta.url).href;
//const model  = new URL('../assets/glb/scene1.glb', import.meta.url).href;



video.play();
video.addEventListener( 'play', function () {
					this.currentTime = 3;
				} );

const startButton = document.getElementById( 'startButton' );
        startButton.addEventListener( 'click', function () { 
          video.play();
          const overlay = document.getElementById( 'overlay' );
          overlay.remove();
        
        } );











import './index.css';

// The SDK is supported on many different browsers, but there are some that
// don't provide camera access. This function detects if the browser is supported
// For more information on support, check out the readme over at
// https://www.npmjs.com/package/@zappar/zappar-threejs
if (ZapparThree.browserIncompatible()) {
  // The browserIncompatibleUI() function shows a full-page dialog that informs the user
  // they're using an unsupported browser, and provides a button to 'copy' the current page
  // URL so they can 'paste' it into the address bar of a compatible alternative.
  ZapparThree.browserIncompatibleUI();

  // If the browser is not compatible, we can avoid setting up the rest of the page
  // so we throw an exception here.
  throw new Error('Unsupported browser');
}

// ZapparThree provides a LoadingManager that shows a progress bar while
// the assets are downloaded. You can use this if it's helpful, or use
// your own loading UI - it's up to you :-)
const manager = new ZapparThree.LoadingManager();

//THREE.ColorManagement.enabled = false;


// Construct our ThreeJS renderer and scene as usual
const renderer = new THREE.WebGLRenderer(
  { antialias: true, alpha: true },
);

renderer.localClippingEnabled = true;
renderer.shadowMap.enabled = true;



const renderTargetParams = {
  minFilter: THREE.LinearFilter,
  magFilter: THREE.LinearFilter,
  format: THREE.RGBAFormat,
  stencilBuffer: true,
};
const renderTarget = new THREE.WebGLRenderTarget(
  window.innerWidth, window.innerHeight, renderTargetParams,
);

const sceneCameraBackground = new THREE.Scene();
document.body.appendChild(renderer.domElement);

// As with a normal ThreeJS scene, resize the canvas if the window resizes
renderer.setSize(window.innerWidth, window.innerHeight);
window.addEventListener('resize', () => {
  renderer.setSize(window.innerWidth, window.innerHeight);
});

// Create a Zappar camera that we'll use instead of a ThreeJS camera
const camera = new ZapparThree.Camera();

// Set sRGB encoding for the renderer and the camera.
renderer.outputEncoding = THREE.sRGBEncoding;
camera.backgroundTexture.encoding = THREE.sRGBEncoding;
renderer.physicallyCorrectLights = true;
renderer.toneMapping = THREE.ACESFilmicToneMapping;

renderer.outputEncoding = THREE.sRGBEncoding;



// In order to use camera and motion data, we need to ask the users for permission
// The Zappar library comes with some UI to help with that, so let's use it
ZapparThree.permissionRequestUI().then((granted) => {
  // If the user granted us the permissions we need then we can start the camera
  // Otherwise let's them know that it's necessary with Zappar's permission denied UI
  if (granted) camera.start();
  else ZapparThree.permissionDeniedUI();
});

// The Zappar component needs to know our WebGL context, so set it like this:
ZapparThree.glContextSet(renderer.getContext());

// Set the background of our scene to be the camera background texture
// that's provided by the Zappar camera

sceneCameraBackground.background = camera.backgroundTexture;
camera.backgroundTexture.encoding = THREE.sRGBEncoding;

// Set an error handler on the loader to help us check if there are issues loading content.
// eslint-disable-next-line no-console
manager.onError = (url) => console.log(`There was an error loading ${url}`);

// Create our portal and portal mask scenes
const scenePortal = new THREE.Scene();
const frontPortal = new THREE.Scene();
const scenePortalMask = new THREE.Scene();

// Create a zappar image_tracker and wrap it in an image_tracker_group for us
// to put our ThreeJS content into
// Pass our loading manager in to ensure the progress bar works correctly
const imageTracker = new ZapparThree.ImageTrackerLoader(manager).load(targetImage);
const imageTrackerGroup = new ZapparThree.ImageAnchorGroup(camera, imageTracker);
const imageTrackerGroup2 = new ZapparThree.ImageAnchorGroup(camera, imageTracker);
const imageTrackerGroup1 = new ZapparThree.ImageAnchorGroup(camera, imageTracker);

// Add our image tracker group into the ThreeJS portal scene
scenePortal.add(imageTrackerGroup);
frontPortal.add(imageTrackerGroup1);

// Add our image tracker group into the ThreeJS portal mask scene
scenePortalMask.add(imageTrackerGroup2);

// Create portal group
const portal = new THREE.Group();
imageTrackerGroup.add(portal);
// Don't show portal immediately
portal.visible = false;




// Define our prompt element and make it show by default
const Prompt = <HTMLDivElement>document.getElementById('Prompt');
Prompt.style.display = 'block';

// Create a variable to discern when the target is
// and is not 'seen' (in view)
let targetSeen = false;



// Create portal group
const fportal = new THREE.Group();
imageTrackerGroup1.add(fportal);
// Don't show portal immediately
fportal.visible = false;

// Set up our portal 'stage'/'room'




const fimage = new THREE.Mesh(
  new THREE.PlaneGeometry(8 , 3),
  new THREE.MeshPhongMaterial(
    {
      map: (new THREE.TextureLoader()).load(BGImage), transparent: true, opacity: 1,
    },
  ),

 // new THREE.MeshBasicMaterial({ color: 0xfaccb2, transparent: true, opacity: .5 }),
);
fimage.position.set(0, 0, 0);
portal.add(fimage);




// Now create our portal mask
const portalMask = new THREE.Group();
imageTrackerGroup2.add(portalMask);
const mask = new THREE.Mesh(
  new THREE.PlaneBufferGeometry(4, 2),
  new THREE.MeshBasicMaterial({ color: 0xffffff }),
);
// Making the mask fit the image
mask.scale.x = 1.0;
portalMask.add(mask);

// Set up our composer and passes
const composer = new EffectComposer(renderer, renderTarget);
const clearPass = new ClearPass();

const cameraBackgroundPass = new RenderPass(sceneCameraBackground, camera);
cameraBackgroundPass.clear = false;

const maskPortalPass = new MaskPass(scenePortalMask, camera);
maskPortalPass.inverse = false;

const portalPass = new RenderPass(scenePortal, camera);
portalPass.clear = false;

const fportalPass = new RenderPass(frontPortal, camera);
fportalPass.clear = false;

const clearMaskPass = new ClearMaskPass();
const outputPass = new ShaderPass(CopyShader);

outputPass.renderToScreen = true;
composer.addPass(clearPass);
composer.addPass(cameraBackgroundPass);

composer.addPass(maskPortalPass);
composer.addPass(portalPass);
composer.addPass(clearMaskPass);
composer.addPass(fportalPass);
composer.addPass(clearMaskPass);
composer.addPass(outputPass);







////
let action: THREE.AnimationAction;
let mixer: THREE.AnimationMixer;
////
// Load a 3D model to place within our group (using ThreeJS's GLTF loader)
const gltfLoader = new GLTFLoader(manager);
gltfLoader.load(model, (gltf) => {
  // get the animation and re-declare mixer and action.
  // which will then be triggered on button press

mixer = new THREE.AnimationMixer(gltf.scene);
action = mixer.clipAction(gltf.animations[0]).play();


// action = mixer.clipAction(gltf.animations[1]).play();
 // action = mixer.clipAction(gltf.animations[2]).play();
 // action = mixer.clipAction(gltf.animations[3]).play();
  gltf.scene.scale.set(1,1,1) // scale here

  // Now the model has been loaded, we can roate it and add it to our image_tracker_group
fportal.add(gltf.scene.rotateX(0));
fportal.add(gltf.scene.rotateY(0 ));
fportal.add(gltf.scene.rotateZ(0));
fportal.add(gltf.scene.translateX(0));
fportal.add(gltf.scene.translateY(-1));
fportal.add(gltf.scene.translateZ(0));

}, undefined, () => {
  console.log('An error ocurred loading the GLTF model');
});







//const light = new THREE.AmbientLight( 'white',2 ); // soft white light
//light.position.set(0, 0, 5);
//portal.add(light);

//const light1 = new THREE.AmbientLight( 'white',4 ); // soft white light
//light1.position.set(0, 3, -3);
//fportal.add(light1);






// Create a directional light which will cast our shadows.
const dirLight = new THREE.DirectionalLight(0xffffff, 1);
dirLight.position.set(0, 30, 0);
dirLight.lookAt(0, 0, 0);

/*
dirLight.castShadow = true;
dirLight.shadow.bias = 0.001;

const shadowDistance = 4;
dirLight.shadow.camera.top = shadowDistance;
dirLight.shadow.camera.bottom = -shadowDistance;
dirLight.shadow.camera.left = -shadowDistance;
dirLight.shadow.camera.right = shadowDistance;

dirLight.shadow.camera.near = 0.1;
dirLight.shadow.camera.far = 50;
dirLight.shadow.radius = 2;
dirLight.shadow.mapSize.width = 1024;
dirLight.shadow.mapSize.height = 1024;
*/

//fportal.add(dirLight);

 //And then a little ambient light to brighten the model up a bit
const ambientLight = new THREE.AmbientLight('white', 3);
portal.add(ambientLight);

 //And then a little ambient light to brighten the model up a bit
 const ambientLight1 = new THREE.AmbientLight('white', 4);
 fportal.add(ambientLight1);

// Set up the real time environment map
const environmentMap = new ZapparThree.CameraEnvironmentMap();
frontPortal.environment = environmentMap.environmentMap;


// Set up the real time environment map
const environmentMap1 = new ZapparThree.CameraEnvironmentMap();
scenePortal.environment = environmentMap1.environmentMap;


















// When we lose sight of the camera, hide the scene contents.
imageTracker.onVisible.bind(() => { portal.visible = true; });
imageTracker.onNotVisible.bind(() => { portal.visible = false; });

imageTracker.onVisible.bind(() => { fportal.visible = true; });
imageTracker.onNotVisible.bind(() => { fportal.visible = false; });



// when we lose sight of the camera, hide the scene contents
// & show our HTML Element prompt
imageTracker.onVisible.bind(() => {
  // Always hide the prompt if the target image is in view
  Prompt.style.display = 'none';

  if (!targetSeen) {
    // If target was once not seen:
    targetSeen = true;
  }
});

// TARGET NOT SEEN
imageTracker.onNotVisible.bind(() => {
  if (targetSeen) {
    // If target was once seen:
    targetSeen = false;

    // Hide the prompt if the target image was previously in view
    // NOTE: We don't put this outside the if function because we
    // want to make sure that it always displays on launch
    Prompt.style.display = 'block';
  }
});











// Used to get deltaTime for our animations.
const clock = new THREE.Clock();
let delta = 0;


// Use a function to render our scene as usual
function render(): void {

camera.backgroundTexture.encoding = THREE.sRGBEncoding;
renderer.outputEncoding = THREE.sRGBEncoding;

  delta = clock.getDelta()
  if (mixer) {
      mixer.update(delta)

  };


  environmentMap.update(renderer, camera);
  environmentMap1.update(renderer, camera);

  // The Zappar camera must have updateFrame called every frame
  camera.updateFrame(renderer);

  // Draw the ThreeJS scene in the usual way, but using the Zappar camera
  // Render first
  renderer.render(sceneCameraBackground, camera);

    // Render second
  renderer.render(scenePortalMask, camera);

    // Render third
  renderer.render(frontPortal, camera);

  // Render third
  renderer.render(scenePortal, camera);


 

  renderer.clear();
  composer.render();
//  composer.addPass( new ShaderPass( GammaCorrectionShader ) );

  // Call render() again next frame
  requestAnimationFrame(render);
}

// Start things off
render();
